import { getPackagingString, isGiftCategory } from '../../model/Product';
import type { Product } from '../../model/types';
import ProductCategoryLinks from './ProductCategoryLinks';
import * as style from './ProductDetails.module.css';
import type { ProductArea } from './ProductOriginLinks';
import ProductOriginLinks from './ProductOriginLinks';

interface Props {
    product: ProductDetails;
}

export interface ProductDetails extends Product, ProductArea {
    smell?: string;
    taste?: string;
    color?: string;
    method?: string;
    allergens?: string;
    environmentLabel?: string;
    cork?: string;
    product_selection?: string;
    storeCategory?: string;
    environmentalPackaging?: string;
    packageType?: string;
    distributor?: string;
    main_producer?: { url?: string; name?: string };
    main_wholesaler?: { url?: string; name?: string };
    year?: string;
}

export default function ProductDetails({ product }: Props) {
    const isGiftPackaging = isGiftCategory(product);
    return (
        <ul className={style.productDetails}>
            <li key="Varetype" data-track-link-click="product-varetype">
                <span>Varetype</span>
                <span>
                    <ProductCategoryLinks product={product} />
                </span>
            </li>
            {renderItem('Varenummer', product.code)}
            {renderItem('Lukt', product.smell)}
            {renderItem('Smak', product.taste)}
            {renderItem('Farge', product.color)}
            {!!product.main_country && (
                <li key="Land, distrikt" data-track-link-click="product-land-distrikt">
                    <span>Land, distrikt</span>
                    <span>
                        <ProductOriginLinks product={product} />
                    </span>
                </li>
            )}
            {renderItem('Produsent', product.main_producer)}
            {!!product.year && (
                <li key="year">
                    <span>Årgang</span>
                    <span>
                        {product.year}
                        <br />
                        <em>Vi tar forbehold om at varen som leveres kan ha en annen årgang/etikett enn oppgitt</em>
                    </span>
                </li>
            )}
            {renderItem('Metode', product.method)}
            {renderItem('Inneholder', product.allergens)}
            {renderItem('Miljøsertifisert produksjon', product.environmentLabel)}
            {renderItem('Emballasjetype', getPackagingString(product))}
            {renderItem('Korktype', product.cork)}
            {!isGiftPackaging && renderItem('Utvalg', product.product_selection)}
            {!isGiftPackaging && renderItem('Kategori', product.storeCategory)}
            {!isGiftPackaging && renderItem('Grossist', product.main_wholesaler)}
            {!isGiftPackaging && renderItem('Transportør', product.distributor)}
        </ul>
    );
}

function renderItem(name: string, value?: string | { name?: string; url?: string }) {
    if (!value) return null;

    if (typeof value === 'string') {
        return (
            <li key={name}>
                <span>{name}</span>
                <span>{value}</span>
            </li>
        );
    }

    return (
        <li key={name} data-track-link-click={`product-${name.toLowerCase()}`}>
            <span>{name}</span>
            <span>
                <a href={value.url} rel="nofollow">
                    {value.name}
                </a>
            </span>
        </li>
    );
}
